class NoAccessError extends Error {
  constructor(message = "You don't have access to this page") {
    super(message)
    this.name = "NoAccessError"
  }
}

export { NoAccessError }
